import {Component, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {FormControl} from '@angular/forms';
import {EndpointsService} from '../services/endpoints-service';
import {switchMap} from 'rxjs/operators';
import {AuthService} from '../services/auth-service';
import {Router} from '@angular/router';
import {QueryParamService} from '../services/query-param-service';
import {PersistentParamsService} from '../shared/persistent-params/persistent-params.service';

@Component({
  selector: 'pair-login-view',
  templateUrl: './pair-login-view.component.html',
  styleUrls: ['./pair-login-view.component.scss'],
})
export class PairLoginViewComponent {
  loading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  pairCodeControl: FormControl;

  constructor(
    private authService: AuthService,
    private endpointsService: EndpointsService,
    private persistentParamsService: PersistentParamsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.pairCodeControl = new FormControl();
  }

  logInWithCode() {
    this.loading$.next(true);
    this.endpointsService
      .logInWithPairingCode(this.pairCodeControl.value.trim())
      .pipe(
        switchMap((response) =>
          this.authService.logInWithCustomToken(response.getCustomToken())
        )
      )
      .subscribe({
        next: () =>
          this.router.navigateByUrl(
            this.persistentParamsService.updateUrl('pair/setup')
          ),
        error: () => {
          this.pairCodeControl.setErrors({invalid: true});
          this.loading$.next(false);
        },
      });
  }
}
